import React, {Component} from 'react';
import * as d3 from 'd3';

import './HoverOver.css';

class HoverOver extends Component {

  defaultState = {
    x: 0,
    y: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    content: '',
    visible: false,
    direction: 'down'
  };

  /**
   * Constructor override
   *
   * @param props
   */
  constructor(props) {
    super(props);

    this.state = this.defaultState;
  }

  /**
   * Called before update, allows us to convert props.data into state
   *
   * @param nextProps
   */
  componentWillReceiveProps(nextProps) {
    const margin = {
      top:nextProps.top || nextProps.margin || this.state.top || 0,
      bottom:nextProps.bottom || nextProps.margin || this.state.bottom || 0,
      left:nextProps.left || nextProps.margin || this.state.left || 0,
      right:nextProps.right || nextProps.margin || this.state.right || 0,
    };

    // Use data.event to create hover contents
    if (nextProps.data && nextProps.data.event) {
      const {event, content} = nextProps.data;
      const hover = this.createHoverFromEvent(event, content);

      this.setState({
        ...margin,
        ...hover
      });
    }
    // Assume formed hover with x,y,content
    else if (nextProps.data) {
      const {x, y, content} = nextProps.data;
      const direction = nextProps.data.direction || this.getDirection(x, y);
      const visible = content && (x > 0 || y > 0);
      this.setState({x, y, content, direction, visible, margin});
    }
    // If no data, hide hover
    else {
      this.setState({visible: false})
    }
  }

  /**
   * Get best hover direction based on x,y coordinates
   *
   * @param x
   * @param y
   * @returns {*}
   */
  getDirection(x, y) {
    const bounds = d3.select(this.refs.wrapper).node().getBoundingClientRect();
    const globalWidth = window.innerWidth;
    const globalX = x + bounds.left;
    const globalY = y + bounds.top;
    const xMargin = Math.max(globalWidth * .1, 100);
    const yMargin = 150;


    if (globalX < xMargin) {
      return 'left';
    }
    else if (globalX > globalWidth - xMargin) {
      return 'right';
    }
    else if (globalY < yMargin) {
      return 'up';
    }
    else {
      return 'down';
    }
  }

  /**
   * Create a hover from mouse event, props, and data
   *
   * @param event
   * @param props
   * @param data
   * @returns {{x: *, y: *, content: *, direction: *, visible: *}}
   */
  createHoverFromEvent(event, content) {
    console.log(event)
    const x = event.clientX;
    const y = event.clientY;
    const direction = this.getDirection(x, y);
    const visible = content && (x > 0 || y > 0);

    return {x, y, content, direction, visible};
  }

  render() {
    return (
      <div ref="wrapper" className="HoverOver wrapper" style={{
        overflow: 'visible !important',
        top: this.state.top || 0,
        bottom: this.state.bottom || 0,
        left: this.state.left || 0,
        right: this.state.right || 0
      }}>
        <div className="position" style={{
          width: 0,
          height: 0,
          overflow: 'visible !important',
          position: 'relative',
          left: this.state.x + "px",
          top: this.state.y + "px",
          display: this.state.visible ? 'block' : 'none'
        }}>
          <div className={"d3tooltip arrow-tooltip-" + this.state.direction}>{this.state.content}</div>
        </div>
      </div>
    );
  }
}

export default HoverOver;


// WEBPACK FOOTER //
// ./src/components/HoverOver.js